import React from 'react';
import moment from 'moment';
import {
  IPlanOverviewDetail,
  ISubjectSubscription,
} from '@models/interfaces/user.interface';
import { CDN_URL } from '@utils/constants/url.constants';
import { subjectCategoryFromId } from '@utils/helpers/SubjectParser';
import { planName } from '@components/subscription/overview/helper/PlanDetailHelper';
import { getRenewalDate } from '@components/subscription/helper/SubscriptionHelper';
import {
  SUBJECTS_USE_CHINESE_COLOR,
  SUBJECTS_USE_ENGLISH_COLOR,
  SUBJECTS_USE_MATH_COLOR,
} from '@utils/constants/subject.constants';

export interface MiniOverviewProps {
  subscription: ISubjectSubscription;
  planDetail: IPlanOverviewDetail;
  isExpired: boolean;
}

const MiniOverview = ({
  subscription,
  isExpired,
  planDetail,
}: MiniOverviewProps) => {
  const expiryDate = moment(subscription?.expiry_date + '+08:00').format(
    'D MMM YYYY',
  );
  const renewDate = getRenewalDate(subscription, planDetail).format(
    'D MMM YYYY',
  );

  function getDescription() {
    if (subscription?.auto_renewal) {
      return 'Renews on ' + renewDate;
    }

    if (!isExpired) {
      return 'Expires on ' + expiryDate;
    }

    return 'Expired on ' + expiryDate;
  }

  function getImageUrl() {
    // this is to bypass type checking because of the API returning string instead of integer
    const subjectId = parseInt(subscription.subject_id as unknown as string);

    return `${CDN_URL}assets/images/subject/${subjectCategoryFromId(
      subjectId,
    )}_simple.svg`;
  }

  const textColor = (subject_id: number): string => {
    const subjectId = parseInt(subject_id as unknown as string);

    if (SUBJECTS_USE_MATH_COLOR.includes(subjectId)) return '#FFAA4D';
    else if (SUBJECTS_USE_ENGLISH_COLOR.includes(subjectId)) return '#71C5E8';
    else if (SUBJECTS_USE_CHINESE_COLOR.includes(subjectId)) return '#C6579A';
    else return '#615e9b';
  };

  return (
    <div className={'flex'}>
      <div
        className={
          'flex-grow-0 flex-shrink-0 w-[37px] h-[37px] rounded-lg relative mr-3'
        }
        style={{
          backgroundColor: isExpired
            ? '#515151'
            : textColor(subscription.subject_id),
        }}
        data-testid={'icon-div'}
      >
        <img
          src={getImageUrl()}
          className={
            'absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 w-[20px]'
          }
          alt={''}
        />
      </div>
      <div>
        <p className={'font-bold text-md leading-[1.2]'}>
          {subscription.is_trial_plan ? 'Trial Version' : planName(planDetail)}•
          {subscription.display_name}
        </p>
        <p className={'text-xs leading-[19px]'}>{getDescription()}</p>
      </div>
    </div>
  );
};

export default MiniOverview;
